module.exports = __webpack_public_path__ + "img/Profil_VP-Profiii_Standard.514c2511.jpg";